module.exports = __webpack_public_path__ + "img/logo-circle.7669c828.png";